import { render, staticRenderFns } from "./SitepresenceSummary.vue?vue&type=template&id=71f0e855&scoped=true"
import script from "./SitepresenceSummary.js?vue&type=script&lang=js&external"
export * from "./SitepresenceSummary.js?vue&type=script&lang=js&external"
import style0 from "./SitepresenceSummary.scss?vue&type=style&index=0&id=71f0e855&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0e855",
  null
  
)

export default component.exports